import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, getMe } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('thru_user');
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('thru_token');
    if (token) {
      getMe()
        .then((res) => { setUser(res.data); localStorage.setItem('thru_user', JSON.stringify(res.data)); })
        .catch(() => { localStorage.removeItem('thru_token'); localStorage.removeItem('thru_user'); setUser(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await apiLogin(email, password);
    localStorage.setItem('thru_token', res.data.access_token);
    localStorage.setItem('thru_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('thru_token');
    localStorage.removeItem('thru_user');
    setUser(null);
  };

  const updateUser = (fields) => {
    setUser((prev) => {
      const updated = { ...prev, ...fields };
      localStorage.setItem('thru_user', JSON.stringify(updated));
      return updated;
    });
  };

  const isAdmin = user?.role === 'admin';
  const isFellow = user?.role === 'fellow' || isAdmin;

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin, isFellow, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
